<template>
  <section class="cart">
    <div class="container-c">
      <div class="header">
        <img :src="url('/media/icons/svg/cart1.svg')" alt="cart icon" />
        <span>{{ trans.get("b2b.cart.cart") }}</span>
        <span class="close" @click="closeCart">
          <img :src="url('/media/icons/svg/close.svg')" alt="close icon" />
        </span>
      </div>
      <div class="cart-body">
        <b-loading :is-full-page="false" v-model="isLoading"></b-loading>
        <cartCard
          class="CartCard"
          v-for="(item, key) in cartItems"
          :cod_art="item.cod_art"
          :quantita="item.quantita"
          :prezzo="item.prezzo"
          :key="key"
          :currentUser="currentUser"
          @refreshTotCarrello="calcolaTotCarrello"
        />
      </div>
      <div class="totale">
        <span>{{ trans.get("b2b.cart.subtotal") }}</span>
        <span v-if="totaleCarrello" class="total-price">
          {{
            totaleCarrello.toLocaleString("it-IT", {
              minimumFractionDigits: 3,
            })
          }}€
        </span>
      </div>
      <div class="checkout">
        <a @click="gotoCheckout" class="link-ret long green">{{
          trans.get("b2b.cart.checkout")
        }}</a>
      </div>
    </div>
  </section>
</template>

<script>
import cartCard from "./cart-card";

export default {
  components: {
    cartCard,
  },
  data() {
    return {
      cartItems: null,
      totaleCarrello: 0,
      // currentUser: null,
      // currentRole: null,
      isLoading: false,
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.nav.user.cod_cli_for
    },
    currentRole() {
      return this.$store.state.nav.user.id_ruolo
    }
  },
  mounted() {
    this.getCart();
    this.calcolaTotCarrello();
    //this.getCurrentUser();
  },

  methods: {
    gotoCheckout: function () {
      console.log(this.cartItems);

      if (this.cartItems === undefined || this.cartItems.length === 0) {
        this.$buefy.dialog.alert({
          title: "Errore",
          message: "Il carrello è vuoto",
          type: "is-danger",
          hasIcon: true,
          icon: "times-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true,
        });
      } else {
        window.location.replace(window.location.origin + "/b2b/checkout");
      }
    },
    getCurrentUser: function () {
      axios({
        method: "get",
        url: window.location.origin + "/data/get-current-user",
      })
        .then((res) => {
          //console.log(res.data)
          this.currentUser = res.data.user;
          this.currentRole = res.data.role;
        })
        .catch((err) => {
          this.$store.commit("add_message", {
            type: "error",
            message: err.response.data.message,
          });
        });
    },
    calcolaTotCarrello: function () {
      axios({
        method: "get",
        url: window.location.origin + "/b2b/cart",
        params: {
          action: "getTotCart",
        },
      })
        .then((result) => {
          //console.log(result)
          this.totaleCarrello = result.data.total;
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    closeCart: function () {
      this.$emit("onCloseCart", true);
      this.$store.commit("closeCart");

    },
    getCart: function () {
      this.isLoading = true;
      axios({
        method: "get",
        url: window.location.origin + "/b2b/cart",
        params: {
          action: "getCart",
        },
      })
        .then((result) => {
          this.cartItems = result.data.data;
          this.$emit("numberItems", this.cartItems.length);
        })
        .catch((error) => {
          this.cartItems = [];
          this.$emit("numberItems", this.cartItems.length);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.link-ret.long {
  height: 50px;
  width: 100%;
  max-width: unset;

}
.cart {
  margin-left: auto;
  width: 100%;
  height: 100%;
  background-color: #ffffff;

  .container-c {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    @media (orientation: landscape) and (max-width: 1400px){
      height: calc(100vh - 80px)
    }

    .header {
      display: flex;
      align-items: center;
      padding: 23px 40px;
      border-bottom: 2px solid #d8d8d8;

      img {
        display: inline-block;
        width: 22px;
        filter: brightness(0);
        margin-right: 25px;
      }

      span {
        display: inline-block;
        font-size: 24px;
      }

      .close {
        margin-left: auto;
        cursor: pointer;

        img {
          width: 15px;
          filter: brightness(0);
        }
      }
    }

    .cart-body {
      display: flex;
      flex-direction: column;
      align-items: center;
      height: calc(100vh - 311px);
      overflow-y: auto;
      overflow-x: hidden;
      -webkit-overflow-scrolling: touch;
      width: auto;
    }

    .totale {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 15px;
      background-color: var(--black-2);
      color: #ffffff;
      margin-top: auto;
      padding: 37px 62px;
      height: 70px;

      .total-price {
        margin-left: auto;
      }
    }

    .checkout {
      a {
        border: none;
        padding: 37px 62px;
        width: 100%;
        height: 70px;
      }
    }
  }
}
</style>
